"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "robella": {
    "96da6393": [{
      "hkey": "9f48cdaa",
      "slug": "robella",
      "name": "Robella",
      "primary": true,
      "skipSearch": false
    }],
    "casa-del-bosco": [{
      "hkey": "9f48cdaa",
      "slug": "robella",
      "name": "Robella",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "585bb036": [{
      "hkey": "9f48cdaa",
      "slug": "robella",
      "name": "Robella",
      "primary": true,
      "skipSearch": false
    }],
    "montaldo": [{
      "hkey": "9f48cdaa",
      "slug": "robella",
      "name": "Robella",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ee16150a": [{
      "hkey": "9f48cdaa",
      "slug": "robella",
      "name": "Robella",
      "primary": true,
      "skipSearch": false
    }],
    "vallese": [{
      "hkey": "9f48cdaa",
      "slug": "robella",
      "name": "Robella",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "3aaee768": [{
      "hkey": "9f48cdaa",
      "slug": "robella",
      "name": "Robella",
      "primary": true,
      "skipSearch": false
    }],
    "vernasso": [{
      "hkey": "9f48cdaa",
      "slug": "robella",
      "name": "Robella",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;